import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchGroupMembershipsArgs,
  FetchClientGroupByIdArgs,
  FetchClientGroupsArgs,
} from '../api/types/clientGroups.types';

import {
  fetchGroupMemberships,
  fetchClientGroupById,
  fetchClientGroups,
} from '../api/clientGroups.api';

export const clientGroupsQueryKeys = createQueryKeys('clientGroups', {
  fetchClientGroupById: ({ id, organizationId }: FetchClientGroupByIdArgs) => ({
    queryFn: () => fetchClientGroupById({ id, organizationId }),
    queryKey: [organizationId, id],
  }),
  fetchClientGroups: ({ organizationId }: FetchClientGroupsArgs) => ({
    queryFn: () => fetchClientGroups({ organizationId }),
    queryKey: [organizationId],
  }),
  fetchGroupMemberships: ({ organizationId }: FetchGroupMembershipsArgs) => ({
    queryFn: () => fetchGroupMemberships({ organizationId }),
    queryKey: [organizationId, 'memberships'],
  }),
});
